var map = {
	"./br/google.png": 54110,
	"./en/google.png": 4817,
	"./fr/google.png": 38498,
	"./ge/google.png": 97814,
	"./la/google.png": 54737,
	"./tw/google.png": 80531,
	"./zh/google.png": 30796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48115;